var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<kendo-tabstrip k-options=\"moduloCtrl.tabOpts\">\n<ul>\n<li class=\"k-state-active\">Moduli</li>\n<li>Menu</li>\n</ul>\n<div>\n<div ng-include=\"'tabmoduli.html'\"></div>\n</div>\n<div>\n<div ng-include=\"'tabmenu.html'\"></div>\n</div>\n</kendo-tabstrip>";
var id1="checkpermessi.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;